import React from "react";
import { useNavigate } from "react-router-dom";
import { useGetActiveToolboxes } from "../../../api/queries";
import { ModuleI } from "../../../types";
import { analytics } from "../../../services/AnalyticsService";
import Spinner from "../../../componentLibrary/Spinner";
import { ErrorDisplay } from "../../../utils/ErrorHandling";

export default function ToolboxList() {
  const navigate = useNavigate();
  const {
    data: activeToolboxes,
    isLoading,
    isError,
    error,
  } = useGetActiveToolboxes();

  const handleOpenToolbox = (module: ModuleI) => {
    navigate(`/my-toolboxes/${module._id}`, {
      state: { from: "/explore" },
    });
    analytics.page({
      category: "Toolbox",
      elementId: module._id,
    });
  };

  if (isLoading) return <Spinner className="mx-auto" />;
  if (isError) return <ErrorDisplay error={error} messageSource="api" />;

  const toolboxes = activeToolboxes?.activeToolboxes ?? [];

  if (toolboxes.length === 0) {
    return (
      <div className="rounded-xl border border-gray-200 bg-white p-4">
        <div className="py-4 text-center">
          <p className="text-sm text-gray-400 py-2">
            You don&apos;t have any toolboxes yet. Complete sections to build
            your toolbox.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      {toolboxes.map((module) => (
        <button
          key={module._id}
          onClick={() => handleOpenToolbox(module)}
          className="flex items-center gap-3 p-3 rounded-xl bg-gray-100 shadow-sm hover:shadow-md transition-shadow text-left focus:outline-none focus:ring-2 focus:ring-electrum-300 cursor-pointer"
        >
          {typeof module.icon !== "string" && (
            <img
              className="w-12 h-12 flex-shrink-0"
              src={module.icon.src}
              alt={module.icon.alt}
            />
          )}
          <div className="min-w-0">
            <div className="font-bold text-base">{module.title}</div>
            {module.subtitle && (
              <div className="text-sm text-electrum">{module.subtitle}</div>
            )}
          </div>
        </button>
      ))}
    </div>
  );
}
